import { render, staticRenderFns } from "./modalRouteTransport.vue?vue&type=template&id=040c5640&scoped=true"
import script from "./modalRouteTransport.vue?vue&type=script&lang=js"
export * from "./modalRouteTransport.vue?vue&type=script&lang=js"
import style0 from "./modalRouteTransport.vue?vue&type=style&index=0&id=040c5640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c5640",
  null
  
)

export default component.exports